import React from 'react';
import * as actions from '../../actions/FormActions'
import { downloadFileLink } from '../../../../helpers/Downloads'
import EditSubscriptionView from '../../../../components/formbuilder/editor/EditSubscriptionView'
import SubscriptionView from '../../../../components/view/SubscriptionView';
import { formatLongToDate } from '../../../../helpers/Data';
import { View, LinkAction, Table, TableColumn, ButtonFields, CheckboxField, Card, FieldsGroup, FieldDetail, SelectField, Icone } from 'react-template';
import "../../../../assets/css/view/formulario/list/tabs/formSubscribed.css"
export default class FormSubscribed extends View {

    multiCertificados = [] // lista global

    constructor(props) {
        super(props);
        const idForm = this.props.params.id;
        this.state = {
            formulario: null,
            tem_presenca: false,
            campoCertificado: '',
            comboCamposComCertificado: [],
            camposComCertificado: [],
            modeloCertificado: '',
            comboModelos: [],
            todosModelos: [],
            dadosCertificado: [], // lista original que vem do serviço
            removerCertificados: [], // lista com IDs para remover
            submissoesParaSalvar: [], // lista com IDs para salvar
            certificadosSemDadosFixos: [],
            data: null,
            url: `/submits/forms/${idForm}`,
            camposFiltrando: '',
            activeLoader: true,
        };



    }

    formatData(resData) {
        let content = [];
        resData.content.forEach(item => {
            let confirmadoPorEmail = item.confirmadoPorEmail;
            let id = item.id;
            let nome = item.nome;
            let cpf = item.cpf;
            let dataSubmissao = item.dataSubmissao;
            let statusPagamento = item.statusPagamento;
            let dadosForm = item.dadosForm;
            let valorBoleto = item.valorBoleto;
            let form = {}
            content.push({ confirmadoPorEmail, id, nome, cpf, dataSubmissao, valorBoleto, statusPagamento, dadosForm, form });
        });
        resData.content = content;
        return resData;
    }

    componentDidMount() {
        this.loadFormulario(this.props.params.id)
        this.getForms(this.state.url + '?size=10');
    }

    loadFormulario(formID) {
        actions.buscarFormulario(formID,
            res => {
                const data = res.data;
                const colSpan = data.certificado ? 6 : 5;

                const { camposComCertificado, comboCamposComCertificado } = this.verificarCamposDeCertificado(data)

                this.setState({
                    ...this.state,
                    formulario: data,
                    tem_presenca: data.certificado,
                    colSpan,
                    camposComCertificado,
                    comboCamposComCertificado
                })
            },
            error => {
                this.notifyError('Erro ao buscar o formulário', '');
            }
        )
    }


    onPaginator = (url) => {
        this.getForms(url + this.state.camposFiltrando)
    }

    onFilter = (camposFiltrando) => {
        const url = this.state.url + '?size=10' + camposFiltrando
        this.setState({ camposFiltrando });
        this.getForms(url, true);
    };

    getForms = (url, filtrando = false) => {
        actions.buscarInscritosDeUmForm(url, res => {
            if (filtrando && res.data.numberOfElements === 0) {
                this.setState({ camposFiltrando: '' })
                this.noResultOnFilter();
                return;
            }
            const resData = this.formatData(res.data);
            this.setState({ data: resData, activeLoader: false });
        }, error => {
            this.setState({ activeLoader: false });
            this.notifyError("Erro ao carregar histórico", "");
        });
    }

    showDetails(e, data) {
        e.preventDefault();
        this.displayModal('Detalhes da inscrição',
            'Detalhes da inscrição realizada por ' + data.nome + ' no dia ' + formatLongToDate(data.dataSubmissao),
            this.contentModal(data));
    }

    showEdit(e, data) {
        e.preventDefault();
        this.displayModal('Edição de inscrição',
            'Edição da inscrição realizada por ' + data.nome + ' no dia ' + formatLongToDate(data.dataSubmissao),
            this.editModal(data));
    }

    arrayDataRemove(value) {
        var newContentState = this.state.data.content.filter(function(ele){
            return ele.id != value.id;
        });
        return newContentState
     }

    deleteSubscription(data) {
        actions.apagarSubmissao(data.id);
        this.setState({data : { ...this.state.data, content : this.arrayDataRemove(data)}});
        this.forceUpdate();
    }
    showMultiDetails(e) {
        e.preventDefault();
        this.displayModal('Liberar Inscrição',
            'Selecione um modelo de Certificado e confirme para libera-lo para os seguintes inscritos: ',
            this.multiContentModal(), this.liberarMultiCertificado.bind(this));
    }

    multiContentModal() {
        return (
            <div>
                {this.state.submissoesParaSalvar.length > 0 && (
                    <FieldsGroup>
                        <FieldDetail width={12} titulo="Salvar certificados de:" />
                        {this.state.submissoesParaSalvar.map(item => (
                            <FieldDetail width={4} >{item.nome}</FieldDetail>
                        ))}
                    </FieldsGroup>
                )}

                {this.state.removerCertificados.length > 0 && (
                    <FieldsGroup>
                        <FieldDetail width={12} titulo="Remover certificados de:" />
                        {this.state.removerCertificados.map(item => (
                            <FieldDetail width={4} >{item.sub.nome}</FieldDetail>
                        ))}
                    </FieldsGroup>
                )}
            </div>
        )
    }

    liberarMultiCertificado() {
        // separa as submissoes e os que deve ser removidos
        let submissoes = this.state.submissoesParaSalvar.map(item => {
            return item.id
        })
        let dadosParaRemover = this.state.removerCertificados.map(item => {
            return item.id
        })
        const modelo = JSON.parse(this.state.modeloCertificado)
        let data = {
            campo: modelo.idCampo,
            modelo: modelo.id,
            submissoes,
            dadosParaRemover
        }

        actions.liberarMulticertificado(data, res => {
            this.setState({
                submissoesParaSalvar: [],
                removerCertificados: [],
                modeloCertificado: '',
                dadosCertificado: res.data
            })
            this.setMultiCertificados(res.data)
            this.notifySucess("Alterações salvas com sucesso.")
        }, error => {
            this.notifyError("Erro", error)
        })
    }

    contentModal(submissao) {
        const key = submissao.id;
        submissao.form = this.state.formulario
        return this.renderSubscriptionView(key, submissao)
    }

    editModal(submissao) {
        const key = submissao.id;
        submissao.form = this.state.formulario
        return this.renderEditSubscriptionView(key, submissao)
    }

    renderSubscriptionView(key, submissao) {
        return (
            <div>
                <SubscriptionView
                    submissao={submissao}
                    pesquisa_submissao={false}
                    tem_presenca={this.state.tem_presenca}
                    key={key}
                    certificadosSemDadosFixos={this.state.certificadosSemDadosFixos}
                    camposComCertificado={this.state.camposComCertificado}
                    todosModelosDeCertificado={this.state.todosModelos} />
            </div>
        )
    }

    renderEditSubscriptionView(key, submissao) {
        return (
            <div>
                <EditSubscriptionView
                    submissao={submissao}
                    pesquisa_submissao={false}
                    tem_presenca={this.state.tem_presenca}
                    key={key}
                    certificadosSemDadosFixos={this.state.certificadosSemDadosFixos}
                    camposComCertificado={this.state.camposComCertificado}
                    todosModelosDeCertificado={this.state.todosModelos} />
            </div>
        )
    }

    verificarCamposDeCertificado(data) {
        actions.buscarTodosOsModelosCertificadoPorForm(this.props.params.id, res => {
            let modelos = res.data.map(m => {
                return {
                    id: m.id,
                    idCampo: m.idCampo,
                    idFormulario: m.idFormulario,
                    tituloModelo: m.tituloModelo
                }
            })

            this.setState({ todosModelos: modelos })

        }, error => {
            this.notifyError('Erro ao tentar buscar informações do Certificado.', '');
        })

        const formEditavel = JSON.parse(data.formEditavel);
        const itens = formEditavel.itens;

        let camposComCertificado = [];
        if (formEditavel.temCertificado) {
            camposComCertificado.push({ item: { pergunta: 'Certificado do Evento', id: 0 } })
        }
        // a cada interação, verifica se o campo é do tipo CERTIFICADO
        // e adiciona um novo objeto contendo o valor do item
        // e a posição do item no array de questoes do FB
        itens.forEach((item, index) => {
            if (item.certificado) {
                camposComCertificado.push({ item: item, index: 'questao_' + item.id });
            }
        })

        // gerando combo
        let comboCamposComCertificado = camposComCertificado.map(c => {
            return this.getObjetCombo(c, c.item.pergunta)
        })

        return { camposComCertificado, comboCamposComCertificado }

    }

    getHomologacao(item) {

        if (!this.state.formulario) return false

        const homologacaoValorBoleto = !(item.valorBoleto !== 0 && item.statusPagamento === false)
        if (item.valorBoleto !== 0 && this.state.formulario.confirmarPorEmail) {
            return homologacaoValorBoleto && item.confirmadoPorEmail
        }

        if (item.valorBoleto !== 0) {
            return homologacaoValorBoleto
        }

        if (this.state.formulario.confirmarPorEmail) {
            return item.confirmadoPorEmail
        }

        return true
    }

    setValorPredefinido(checked, data) {
        try {

            const dados = this.state.dadosCertificado.find(d => {
                return d.sub.id === data.id
            })

            if (checked) {
                // adiciona no global
                this.multiCertificados.push(data)

                // removendo da lista de removerCertificados caso exista na lista original
                if (dados) {
                    let removerCertificados = this.state.removerCertificados.filter((n) => {
                        return n.sub.id !== data.id
                    })
                    this.setState({ removerCertificados })
                }
            } else {
                // remove do global
                this.multiCertificados = this.multiCertificados.filter((n) => {
                    return n.id !== data.id
                })

                // adicionando na lista de removerCertificados caso exista na lista original
                if (dados) {
                    let removerCertificados = this.state.removerCertificados
                    removerCertificados.push(dados)
                    this.setState({ removerCertificados })
                }
            }

            let submissoesParaSalvar = this.multiCertificados.filter(n => {
                if (!this.state.dadosCertificado.some(o => n.id === o.sub.id)) {
                    return n
                }
            })

            this.setState({ submissoesParaSalvar })
            this.forceUpdate()
        } catch (error) { console.log(error) }
    }

    verificarCheckbox(id) {
        let sub = this.multiCertificados.find(s => {
            return s.id === id;
        })

        return sub
    }

    getItensComCertificado(submissao) {
        try {
            const itens = JSON.parse(submissao.form.formEditavel).itens
            const formSchema = JSON.parse(submissao.form.formSchema)
            let itensComCertificado = []

            const formEditavelJson = JSON.parse(submissao.form.formEditavel);
            if (formEditavelJson.temCertificado) {
                itensComCertificado.push({ titulo: 'Certificado do Evento', resposta: "", itemId: null });
            }

            let dadosFormJson = JSON.parse(submissao.dadosForm.replace(/'/g, '"'));

            for (let itemName in dadosFormJson) {
                // pega o index o item
                var i = itemName.split('_')[1];
                const itemSubmissao = dadosFormJson[itemName];
                const itemTitulo = (formSchema.schema.properties[itemName] !== undefined ? formSchema.schema.properties[itemName].title : 'Questão removida do formulário');
                // separa os que tem e não tem certificado
                if ((itens.find(item => item.id + '' === i) !== undefined) && (itens.find(item => item.id === parseInt(i, 10)).certificado)) {
                    itensComCertificado.push({ titulo: itemTitulo, resposta: itemSubmissao, itemId: i });
                }
            }
            return { itensComCertificado };
        } catch (error) { }
    }

    getOpcaoCampoCertificado(opcoes) {
        return (
            <ul>
                {opcoes.map(o => (
                    <li key={o.itemId}> {o.titulo} - {o.resposta}</li>
                ))}
            </ul>
        )
    }

    disabledCheckbox(sub) {
        try {

            if (!(this.state.modeloCertificado !== null && this.state.modeloCertificado.length > 0)) {
                return true
            }

            if (this.verificarCheckbox(sub.id)) {
                const dados = this.state.dadosCertificado.find(d => {
                    return d.sub.id === sub.id //JSON.parse(this.state.modeloCertificado).id
                })

                if (dados.modeloCertificado.id !== JSON.parse(this.state.modeloCertificado).id) {
                    return true
                }
            }
        } catch (error) { console.log(error) }
    }

    checkboxOrIcon(sub) {
        if (this.verificarCheckbox(sub.id) && this.disabledCheckbox(sub)) {
            return (<Icone icone="done" />)
        }
        return (
            <CheckboxField onChange={(e, res) => this.setValorPredefinido(res.checked, sub)} disabled={this.disabledCheckbox(sub)} value={this.verificarCheckbox(sub.id)} />
        )
    }


    dataMapper = (data) => {
        let itensComCertificado = []
        try {
            data.form = this.state.formulario
            itensComCertificado = this.getItensComCertificado(data).itensComCertificado
        } catch (error) { }
        if (itensComCertificado.length > 0) {
            return (
                <tr key={data.id}>
                    <TableColumn width="20" headers="nome" content={data.nome} label="Nome" filter={{ atributo: 'nome', coluna: 'Nome', tipo: 'String' }} />
                    <TableColumn width="15" headers="cpf" content={data.cpf} label="CPF" filter={{ atributo: 'cpf', coluna: 'CPF', tipo: 'String', mascara: '000.000.000-00' }} />
                    <TableColumn width="5" headers="dataSubmissao" content={formatLongToDate(data.dataSubmissao)} label="Data da inscrição" filter={{ atributo: 'dataSubmissao', coluna: 'Data da inscrição', tipo: 'Date' }} />
                    <TableColumn width="5" headers="status" content={this.getHomologacao(data)} label="Confirmação da inscrição" status filter={{ atributo: 'status', coluna: 'Confirmação da inscrição', tipo: 'Boolean' }} />
                    <TableColumn width="30" headers="certificado" content={this.getOpcaoCampoCertificado(itensComCertificado)} label="Certificado" />
                    <TableColumn width="10" headers="acoes" action>
                        <LinkAction icone="more" type="table" onClick={(e) => this.showDetails(e, data)} tooltip="Detalhar" />
                        {this.checkboxOrIcon(data)}
                    </TableColumn>
                    <TableColumn width="5" headers="acoes" action>
                        <LinkAction icone="edit" type="table" onClick={(e) => this.showEdit(e, data)} tooltip="Detalhar" />
                    </TableColumn>
                    <TableColumn width="5" headers="acoes" action>
                        <LinkAction icone="delete" type="table" onClick={() => { if (window.confirm('Voce tem certeza que quer deletar a inscricao do cpf ' + data.cpf)) this.deleteSubscription(data) }} tooltip="Remover" />
                    </TableColumn>
                </tr>
            );
        }

        return (
            <tr key={data.id}>
                <TableColumn width="20" headers="nome" content={data.nome} label="Nome" filter={{ atributo: 'nome', coluna: 'Nome, CPF ou Lista separada por virgulas', tipo: 'String' }} />
                <TableColumn width="15" headers="cpf" content={data.cpf} label="CPF" />
                <TableColumn width="5" headers="dataSubmissao" content={formatLongToDate(data.dataSubmissao)} label="Data da inscrição" filter={{ atributo: 'dataSubmissao', coluna: 'Data da inscrição', tipo: 'Date' }} />
                <TableColumn width="5" headers="status" content={this.getHomologacao(data)} label="Confirmação da inscrição" status filter={{ atributo: 'status', coluna: 'Confirmação da inscrição', tipo: 'Boolean' }} />
                <TableColumn width="10" headers="acoes" action>
                    <LinkAction icone="more" type="table" onClick={(e) => this.showDetails(e, data)} tooltip="Detalhar" />
                </TableColumn>
                <TableColumn width="5" headers="acoes" action>
                    <LinkAction icone="edit" type="table" onClick={(e) => this.showEdit(e, data)} tooltip="Editar" />
                </TableColumn>
                <TableColumn width="5" headers="acoes" action>
                    <LinkAction icone="delete" type="table" onClick={() => { if (window.confirm('Voce tem certeza que quer deletar a inscricao do cpf ' + data.cpf)) this.deleteSubscription(data) }} tooltip="Remover" />
                </TableColumn>
            </tr>
        );
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    getTools() {
        return (
            <div>
                <ButtonFields button='flat' color='red' mini title='Download Lista de Inscritos como PDF' onClick={() => this.downloadRelatorioPDF()}>
                    <Icone icone='file-pdf' size='huge' fontAwesome fab="far" />
                    PDF
                </ButtonFields>
                <ButtonFields button='flat' color='green' mini title='Download Lista de Inscritos como CSV' onClick={() => this.downloadRelatorioCSV()}>
                    <Icone icone='file-excel' size='huge' fontAwesome fab="far" />
                    CSV
                </ButtonFields>
            </div>
        )
    }

    renderTable() {
        return (
            <Table title="Inscritos"
                summary="Inscrições realizadas no formulário"
                url={this.state.url}
                data={this.state.data}
                onFilter={this.onFilter}
                dataMapper={this.dataMapper}
                onPaginator={this.onPaginator}
                noPadding />
        )
    }

    // Downloads de Relatórios
    // CSV
    downloadRelatorioCSV() {
        this.setState({ activeLoader: true });
        actions.downloadListaInscritosFormularioCSV(this.props.params.id, res => {
            const formSchema = JSON.parse(this.state.formulario.formSchema)
            downloadFileLink(res.data, "Lista de Inscritos - " + formSchema.schema.title, "text/csv")
            this.setState({ activeLoader: false });
        },
            error => {
                this.setState({ activeLoader: false });
                this.notifyError('Erro ao realizar Download', '');
            })
    }
    // PDF
    downloadRelatorioPDF() {
        this.setState({ activeLoader: true });
        actions.downloadListaInscritosFormularioPDF(this.props.params.id, res => {
            const formSchema = JSON.parse(this.state.formulario.formSchema)
            downloadFileLink(res.data, "Lista de Inscritos - " + formSchema.schema.title)
            this.setState({ activeLoader: false });
        }, error => {
            this.setState({ activeLoader: false });
            this.notifyError('Erro ao realizar Download', '');
        });
    }

    setMultiCertificados(data) {
        this.multiCertificados = []
        if (data.length > 0) {
            data.forEach(s => {
                this.multiCertificados.push(s.sub)
            })
        }
        this.forceUpdate()
    }

    handleChangeCampoCertificado(e, { name, value }) {
        this.handleChange(e, { name, value })

        actions.dadosCertificadosPorCampo(this.props.params.id, JSON.parse(value).item.id, res => {
            this.setState({ dadosCertificado: res.data })
            this.setMultiCertificados(res.data)
        }, error => {
            this.notifyError("Erro", error)
        })

    }
    atualizarModelo(e, { name, value }) {
        this.handleChange(e, { name, value })

        this.setMultiCertificados(this.state.dadosCertificado)

        this.setState({ submissoesParaSalvar: [], removerCertificados: [] })
        this.forceUpdate()
    }
    handleChangeModeloCertificado(e, { name, value }) {
        if (this.state.submissoesParaSalvar.length > 0 || this.state.removerCertificados.length > 0) {
            this.displayModal('Mudança de Modelo', '',
                'Ao mudar o modelo, as alterações feitas serão perdidas. Confirme para alterar o modelo.', () => { this.atualizarModelo(e, { name, value }) });
        } else this.atualizarModelo(e, { name, value })

    }

    getComboCamposComCertificado() {
        try {
            let modelos = []
            modelos = this.state.todosModelos.filter(modelo => {
                return modelo.idCampo === JSON.parse(this.state.campoCertificado).item.id
            })
            return modelos.map(m => {
                return this.getObjetCombo(m, m.tituloModelo)
            })
        } catch (error) { console.log(error) }
    }

    disabledLiberarCertificado() {
        return this.state.campoCertificado !== null && this.state.campoCertificado.length > 0
            && this.state.modeloCertificado !== null && this.state.modeloCertificado.length > 0
            && ((this.state.submissoesParaSalvar !== null && this.state.submissoesParaSalvar.length > 0)
                || (this.state.removerCertificados !== null && this.state.removerCertificados.length > 0)) ? false : true
    }

    getActions() {
        if (this.state.formulario && this.state.formulario.certificado)
            return (
                <div>
                    <SelectField required invalidMessage="O campo é de preenchimento obrigatório"
                        value={this.state.campoCertificado}
                        name="campoCertificado"
                        label='Campo de Certificado'
                        placeholder='Selecione um Campo'
                        options={this.state.comboCamposComCertificado}
                        onChange={this.handleChangeCampoCertificado.bind(this)}
                        width={4}
                    />
                    <SelectField required invalidMessage="O campo é de preenchimento obrigatório"
                        value={this.state.modeloCertificado}
                        name="modeloCertificado"
                        label='Modelo de Certificado'
                        placeholder='Selecione um Modelo'
                        options={this.getComboCamposComCertificado()}
                        onChange={this.handleChangeModeloCertificado.bind(this)}
                        width={4}
                    />
                    <ButtonFields content="Liberar Certificado" color="green" disabled={this.disabledLiberarCertificado()} button="colored" onClick={(e) => this.showMultiDetails(e)} />
                </div>
            )
    }

    render() {
        return (
            <div id='listing-subscribed'>
                <Card titulo='Inscritos' descricao='Inscrições realizadas no formulário' noPadding
                    tools={this.getTools()} actions={this.getActions()} displayLoading={this.state.activeLoader} loadingPosition='top' >
                    {this.renderTable()}
                </Card>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/view/formulario/list/tabs/FormSubscribed.js